

class VariantPicker extends HTMLElement {
  connectedCallback() {
    const data = this.querySelector('[data-variants]');
    this.form = this.closest('form');
    if (!data || !this.form) return;
    try {
      this.variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    this.idInput = this.form.querySelector('[name="id"]');
    this.addEventListener('change', () => this.update());
    this.update(true);
  }

  
  selectedOptions() {
    return Array.from(this.querySelectorAll('.option-group')).map((group) => {
      const select = group.querySelector('select.option-select');
      if (select) return select.value;
      const checked = group.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    });
  }

  update(initial) {
    const chosen = this.selectedOptions();
    const match = this.variants.find((v) =>
      v.options.every((opt, i) => opt === chosen[i])
    );

    this.querySelectorAll('[data-option-display]').forEach((el, i) => {
      el.textContent = chosen[i] || '';
    });

    const priceEl = document.getElementById('price-' + this.dataset.sectionId);
    const addBtn = document.getElementById('add-' + this.dataset.sectionId);
    const barBtn = document.getElementById('bar-add-' + this.dataset.sectionId);

    if (!match) {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = S.unavailable;
      }
      return;
    }

    this.idInput.value = match.id;
    document.dispatchEvent(new CustomEvent('variant:changed', { detail: match }));

    if (!initial && match.url) {
      window.history.replaceState({}, '', match.url);
    }

    if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;

    [addBtn, barBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !match.available;
      btn.textContent = match.available ? S.addToCart : S.soldOut;
    });
  }
}
customElements.define('variant-picker', VariantPicker);

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.errorTarget = this.querySelector('[data-form-error]');
    if (!this.form) return;
    this.form.addEventListener('submit', (e) => this.submit(e));
  }

  showError(message) {
    if (this.errorTarget) {
      this.errorTarget.textContent = message;
      this.errorTarget.hidden = false;
    } else {
      const live = document.getElementById('cart-live-region');
      if (live) live.textContent = message;
    }
  }

  clearError() {
    if (this.errorTarget) {
      this.errorTarget.textContent = '';
      this.errorTarget.hidden = true;
    }
  }

  async submit(e) {
    e.preventDefault();
    this.clearError();

    const btn = this.form.querySelector('[type="submit"]');
    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = S.adding;

    try {
      const fd = new FormData(this.form);
      const item = { id: fd.get('id'), quantity: parseInt(fd.get('quantity') || '1', 10) };
      if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
      const properties = {};
      for (const [key, value] of fd.entries()) {
        const m = key.match(/^properties\[(.+)\]$/);
        if (!m || String(value).trim() === '') continue;
        const field = this.form.querySelector(`[name="${CSS.escape(key)}"]`);
        const unit = field?.dataset.unit ? ` ${field.dataset.unit}` : '';
        properties[m[1]] = `${String(value).trim()}${unit}`;
      }
      if (Object.keys(properties).length) item.properties = properties;
      this.lastProperties = properties;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        const message =
          (data && (data.description || data.message)) ||
          (res.status === 422
            ? S.errorUnavailable
            : S.errorGeneric);
        this.showError(message);
        btn.textContent = original;
        btn.disabled = false;
        return;
      }

      await refreshCart();
      btn.textContent = S.added;
      if (drawers.cart) drawers.cart.open();
      this.form.querySelectorAll('[data-measure-input]').forEach((input) => {
        const value = input.value.trim();
        if (!value) return;
        const row = input.closest('.measure');
        const note = row && row.querySelector('[data-measure-note]');
        if (!note) return;
        const unit = input.dataset.unit ? ` ${input.dataset.unit}` : '';
        const what = row.dataset.confirm || "we'll hem it to";
        note.hidden = false;
        note.textContent = `Added — ${what} ${value}${unit}. It's saved on your order.`;
      });
      setTimeout(() => {
        btn.textContent = original;
        btn.disabled = false;
      }, 1200);
    } catch (err) {
      this.showError(
        navigator.onLine === false
          ? S.errorOffline
          : S.errorGeneric
      );
      btn.textContent = original;
      btn.disabled = false;
    }
  }
}
customElements.define('product-form', ProductForm);

document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-buy-bar]');
  const anchor = document.querySelector('[data-buy-anchor]');
  if (!bar || !anchor || !('IntersectionObserver' in window)) return;

  new IntersectionObserver(
    ([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting),
    { rootMargin: '0px 0px -120px 0px' }
  ).observe(anchor);
});

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url) return;
    const load = () => {
      observer.disconnect();
      const url = this.dataset.url.replace('intent=', '') + '&intent=' + (this.dataset.intent || 'related');
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const fresh = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim().length) {
            this.innerHTML = fresh.innerHTML;
          } else {
            this.remove();
          }
        })
        .catch(() => this.remove());
    };
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) load();
    }, { rootMargin: '400px' });
    observer.observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);

const RECENT_KEY = 'recently-viewed';

function readRecent() {
  try {
    return JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
  } catch (e) {
    return [];
  }
}

function rememberProduct(handle) {
  if (!handle) return;
  try {
    const list = readRecent().filter((h) => h !== handle);
    list.unshift(handle);
    window.localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
  } catch (e) {
    
  }
}

class RecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const limit = parseInt(this.dataset.limit || '4', 10);
    const handles = readRecent().filter((h) => h !== this.dataset.currentHandle).slice(0, limit);
    if (!handles.length) return;

    const list = this.querySelector('[data-recently-viewed-list]');
    const cards = await Promise.all(
      handles.map((handle) =>
        fetch(`/products/${handle}?section_id=card-fragment`)
          .then((r) => (r.ok ? r.text() : ''))
          .catch(() => '')
      )
    );
    const html = cards.filter(Boolean).join('');
    if (!html.trim()) return;
    list.innerHTML = html;
    this.hidden = false;
  }
}
customElements.define('recently-viewed', RecentlyViewed);

document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-sizeguide-open]');
  if (open) {
    const panel = open.closest('.sizeguide').querySelector('[data-sizeguide]');
    panel.hidden = false;
    document.body.style.overflow = 'hidden';
    panel.querySelector('[data-sizeguide-close]')?.focus();
    return;
  }
  const close = e.target.closest('[data-sizeguide-close]');
  if (close) {
    close.closest('[data-sizeguide]').hidden = true;
    document.body.style.overflow = '';
  }
});
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('[data-sizeguide]:not([hidden])').forEach((p) => {
    p.hidden = true;
    document.body.style.overflow = '';
  });
});

document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-measure-toggle]');
  if (!t) return;
  const panel = document.getElementById(t.getAttribute('aria-controls'));
  const open = t.getAttribute('aria-expanded') === 'true';
  t.setAttribute('aria-expanded', String(!open));
  if (panel) { panel.hidden = open; if (!open) panel.querySelector('input')?.focus(); }
});
document.addEventListener('input', (e) => {
  const inp = e.target.closest('[data-measure-input]');
  if (!inp) return;
  const note = inp.closest('.measure')?.querySelector('[data-measure-note]');
  if (note) note.hidden = inp.value.trim() === '';
});
